import { FC } from "react";
import { FieldValues } from "react-hook-form";
import {
  MuiBox,
  MuiDoubleLabel,
  MuiGrid,
} from "../../../../../../../../../../../components";
import { UnitTypesKey } from "../../../../../../../../../../../helpers/constants/siteCoreKeys";
import { useGridContainer } from "../../../../../../../../../../../hooks/useGridContainer";
import { useSiteCore } from "../../../../../../../../../../../hooks/useSiteCore";
import { defaultActivityValuesSiteCoreKeys } from "../../../siteCore/SiteCoreKeys";
import { TopicDetails } from "../../../../../../../../../../../api/services/project/model";

interface ProjectViewActivityDefaultTabProps extends FieldValues {
  activityData: TopicDetails;
}

export const ProjectViewActivityDefault: FC<
  ProjectViewActivityDefaultTabProps
> = ({ activityData }) => {
  const { gridSizeMedium: gridSize, gridSizeMediumClass } =
    useGridContainer(true);
  const { fetchLabel, fetchValueByKeyOfDropdown } = useSiteCore();

  const getUnitText = () => {
    if (activityData?.units === UnitTypesKey.Minutes) {
      return defaultActivityValuesSiteCoreKeys.minutes;
    } else if (activityData?.units === UnitTypesKey.Count) {
      return defaultActivityValuesSiteCoreKeys.quantity;
    } else if (activityData?.units === UnitTypesKey.Days) {
      return defaultActivityValuesSiteCoreKeys.numberOfDays;
    } else {
      return defaultActivityValuesSiteCoreKeys.halfDay;
    }
  };

  const getMeasurementValue = () => {
    if (!activityData?.units) {
      return "";
    }
    if (activityData.units === UnitTypesKey.Minutes) {
      return fetchValueByKeyOfDropdown(
        defaultActivityValuesSiteCoreKeys.defaultActivityValues,
        defaultActivityValuesSiteCoreKeys.minutesList,
        activityData.measurement,
      );
    }
    return activityData.measurement;
  };
  return (
    <MuiBox>
      <MuiGrid
        container
        data-testid="activity-tab-default"
        className="activity-tab-general"
      >
        <MuiGrid size={gridSize} className={gridSizeMediumClass}>
          <MuiDoubleLabel
            label={fetchLabel(
              defaultActivityValuesSiteCoreKeys.defaultActivityValues,
              defaultActivityValuesSiteCoreKeys.units,
            )}
            value={fetchValueByKeyOfDropdown(
              defaultActivityValuesSiteCoreKeys.defaultActivityValues,
              defaultActivityValuesSiteCoreKeys.unitLists,
              activityData?.units ?? "",
            )}
          />
        </MuiGrid>
        <MuiGrid size={gridSize} className={gridSizeMediumClass}>
          <MuiDoubleLabel
            data-testid="measurement"
            label={fetchLabel(
              defaultActivityValuesSiteCoreKeys.defaultActivityValues,
              getUnitText(),
            )}
            value={getMeasurementValue()}
          />
        </MuiGrid>
      </MuiGrid>
    </MuiBox>
  );
};
